import axios from 'axios'

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'
const SAVE_ME = 'SAVE_ME'

// initial state
const state = {
  token: localStorage.getItem('token') || '',
  me: null
}

const getters = {
  isLoggedIn: state => !!state.token,
  me: state => state.me,
  isAdmin: state => state.me && state.me.accountmanager === 5,
  isManager: state => state.me && state.me.accountmanager === 1
}

const actions = {
  login ({ commit, dispatch }, creds) {
    commit(LOGIN) // show spinner
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      axios.post(process.env.API + '/session/admin/', {
        email: creds.email,
        password: creds.password
      })
        .then(response => {
          if (response.data.token) {
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('token-expire', Math.floor(Date.now() / 1000) + response.data.duration - 60 * 3)
            axios.defaults.headers.common['X-Token'] = response.data.token
            commit(LOGIN_SUCCESS, response.data.token)

            resolve(response)
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getInfos ({ commit, rootGetters }) {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      axios.get(process.env.API + '/user/')
        .then(response => {
          let admins = rootGetters['account/admins']

          admins.forEach((admin) => {
            if (admin.user.id === response.data.id) {
              response.data.accountmanager = admin.accountmanager
            }
          })

          commit(SAVE_ME, response.data)
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  logout ({ commit, dispatch }) {
    delete axios.defaults.headers.common['X-Token']
    localStorage.removeItem('token')
    dispatch('badges/resetBadges', {}, {root: true})
    dispatch('events/resetEvents', {}, { root: true })
    dispatch('libraries/resetLibraries', {}, { root: true })
    dispatch('medias/resetMedias', {}, { root: true })
    dispatch('challenges/resetChallenges', {}, { root: true })
    dispatch('kpis/resetKpis', {}, { root: true })
    dispatch('advices/resetAdvices', {}, { root: true })
    dispatch('account/resetAccount', {}, { root: true })

    commit(LOGOUT)
  },

  softLogout ({ commit, dispatch }) {
    delete axios.defaults.headers.common['X-Token']
    localStorage.removeItem('token')
    localStorage.removeItem('token-expire')
    commit(LOGOUT)
  },

  initApplication ({ dispatch }) {
    let interval = setInterval(() => {
      let expire = localStorage.getItem('token-expire') * 1000
      if (expire < Date.now()) {
        console.log('disconnect')
        dispatch('softLogout')
        clearInterval(interval)
      }
    }, 10000)

    // Get configuration
    return dispatch('campaigns/resetCampaigns', {}, {root: true})
      .then(() => {
        return dispatch('badges/resetBadges', {}, {root: true})
      })
      .then(() => {
        return dispatch('events/resetEvents', {}, { root: true })
      }).then(() => {
        return dispatch('libraries/resetLibraries', {}, { root: true })
      }).then(() => {
        return dispatch('medias/resetMedias', {}, { root: true })
      }).then(() => {
        return dispatch('challenges/resetChallenges', {}, { root: true })
      }).then(() => {
        // Reset campaign list
        return dispatch('account/LOAD_ACCOUNT', {}, { root: true })
      }).then(() => {
        // Reset campaign list
        return dispatch('user/getInfos', {}, { root: true })
      })
  },

  updateUser ({ commit, dispatch }, {user, token}) {
    return new Promise((resolve, reject) => {
      axios.put(process.env.API + '/user/', user)
        .then((response) => {
          commit(SAVE_ME, response.data)
          resolve()
        }, (e) => {
          reject(e)
        })
    })
  },
  resetPassword ({ commit, dispatch }, {user, token}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['X-Token'] = token
      axios.put(process.env.API + '/user/', user)
        .then((response) => {
          commit(SAVE_ME, response.data)
          resolve()
        }, (e) => {
          reject(e)
        })
    })
  },
  rememberPassword ({ commit, dispatch }, email) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.API + '/user/remember/', {email: email})
        .then((response) => {
          resolve()
        }, (e) => {
          reject(e.response.data)
        })
    })
  }
}
const mutations = {
  [LOGIN] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state, token) {
    state.token = token
    state.pending = false
  },
  [LOGOUT] (state) {
    state.token = null
    state.isLoggedIn = false
  },
  [SAVE_ME] (state, user) {
    state.me = user
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js